import React from 'react';
import toElement from 'util/toElement';
import { useLocation } from 'react-router-dom';
import { wrapTables } from 'util/wrapTables';
import { applyFocusedClass } from 'util/applyFocusedClass';

export function useContentDocument(documentContentStringified: string) {
  const location = useLocation();

  return React.useMemo(() => {
    const contentEl = toElement(documentContentStringified);
    if (contentEl) {
      wrapTables(
        contentEl,
        'table:not([style="caption"]):not([style="signature"]):not([wrapped])',
      );
      applyFocusedClass(contentEl, location.hash);

      return contentEl;
    }
  }, [documentContentStringified, location]);
}
